import React from "react";

// i18n
import { useTranslation } from "react-i18next";

// React Flow
import { Handle } from "@xyflow/react";

// MUI
import Typography from "@mui/material/Typography";

// Components
import Progress from "../../../../components/progress";

// Styles
import styles from "./course.module.scss";

const UnitNode = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div id={data.id} className={styles.courseNode}>
      <div className="flex flex-row items-center justify-between w-full">
        <Typography variant="body2" color="textPrimary" className={styles.courseNodeLabel}>
          {t('masteryMap.course_label', { index: data.index + 1 })}
        </Typography>

        <div className={`${styles.courseNodeProgressContainer} flex-1`}>
          <Typography variant="body2" className={styles.courseNodeProgressText}>
            {data.progress}%
          </Typography>

          {!!data.progress && <Progress progress={data.progress} classes={{ progressBar: styles.unitNodeProgressBar }} />}
        </div>
      </div>

      <Typography variant="body2" color="textSecondary" className={styles.courseNodeLabel}>
        {data.label}
      </Typography>

      <Handle type="source" position="right" style={{ opacity: 0, pointerEvents: 'none' }} />
    </div>
  )
}

export default UnitNode;
